import { jsx as _jsx } from "react/jsx-runtime";
import { DialogTitle } from '@mui/material';
import { theme } from '../../themes';
export const AddAbsenceTitleDialog = ({ children }) => {
    return (_jsx(DialogTitle, { style: { paddingBottom: '10px', paddingTop: '8px', paddingLeft: '10px' }, borderBottom: '0.5px solid', borderColor: theme.palette.primary.main, children: children }));
};
